import { render } from "./About.vue?vue&type=template&id=700b810d&scoped=true"
const script = {}

import "./About.vue?vue&type=style&index=0&id=700b810d&lang=less&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-700b810d"]])

export default __exports__